export default "__VITE_ASSET__BOcwB6tO__"